import { ReportType } from "../models/report-types";

export const reportsWithSummary: Record<ReportType | string, boolean> = {
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS]: true,
  [ReportType.REPORTE_GENERAL]: true,
  [ReportType.REPORTE_COMBUSTIBLE_GENERAL]: true,
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS_NUEVO]: true,
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS_ENHANCED]: true,

};
